import React from 'react';
import { FlexAlign, FlexDirection, FlexGapSize, FlexJustify } from './flexTypes';





interface FlexProps {
    justify?: FlexJustify;
    align?: FlexAlign;
    gapSize?: FlexGapSize;
    direction?: FlexDirection;
    fullHeight?: boolean;
    grow?: boolean;
    shrink?: boolean;
    wrap?: boolean;
    width?: string;
    id?: string;
    children?: React.ReactNode;
    className?: string;
}

const getGapSize = (size: FlexGapSize): number => {
    switch (size) {
        case FlexGapSize.XSmall:
            return 8;
        case FlexGapSize.Small:
            return 12;
        case FlexGapSize.Medium:
            return 24;
        case FlexGapSize.Large:
            return 36;
    }
};

const Flex: React.FC<FlexProps> = ({
    justify = FlexJustify.Center,
    align = FlexAlign.Center,
    gapSize,
    direction = FlexDirection.Horizontal,
    fullHeight = false,
    grow = false,
    shrink = false,
    wrap = false,
    width,
    id,
    children,
    className = '',
}) => {
    const gapSizeValue = gapSize ? getGapSize(gapSize) : undefined;

    // Convert direction to CSS flex-direction
    const flexDirection = direction === FlexDirection.Vertical ? 'column' : 'row';

    const baseStyle: React.CSSProperties = {
        display: 'flex',
        flexDirection,
        flexWrap: wrap ? 'wrap' : undefined,
        justifyContent: justify,
        alignItems: align,
        gap: gapSizeValue ? `${gapSizeValue}px` : undefined,
        height: fullHeight ? '100%' : undefined,
        flex: grow ? 1 : undefined,
        minWidth: shrink ? 0 : undefined,
        width: width || undefined,
    };

    return (
        <div id={id} className={className} style={baseStyle}>
            {children}
        </div>
    );
};

export default Flex;
